// Supported inverter brands for device registration.
// Keep this list in sync with whatever your inventory
// database actually recognizes.
const INVERTER_BRANDS = [
    "Apollo",
    "Crown / Crown Micro",
    "Delta Power",
    "Delux",
    "Dungjin",
    "Fronus",
    "Galaxy",
    "Growatt",
    "Homage",
    "Inverex (Except Nitrox models)",
    "Itel",
    "Knox",
    "Long Life",
    "Maxpower",
    "Next Power",
    "Omega",
    "OnGrid",
    "Power Square",
    "Premo Energy",
    "Primax",
    "Raybit",
    "Sako",
    "Solarmax",
    "Solax",
    "Solis",
    "Sunfu",
    "Sungrow",
    "Sunlife",
    "Techorse",
    "Tesla",
    "TRION",
    "Victor",
    "Ziewnic",
    "Voltronic Power",
    "Other"
];

export default INVERTER_BRANDS;
